interface Props {
    width: string;
    height: string;
}

export const Shimmer = (props: Props) => {
    const { width, height } = props;
    return (
        <svg
            width={width}
            height={height}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <linearGradient id="g">
                    <stop stopColor="#E5E5E5" offset="20%" />
                    <stop stopColor="#FAFAFA" offset="50%" />
                    <stop stopColor="#E5E5E5" offset="70%" />
                </linearGradient>
            </defs>
            <rect width={width} height={height} fill="#E5E5E5" />
            <rect id="r" width={width} height={height} fill="url(#g)" />
            <animate
                xlinkHref="#r"
                attributeName="x"
                from={`-${width}`}
                to={width}
                dur="1s"
                repeatCount="indefinite"
            />
        </svg>
    );
};
